import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

function Affiliate() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    useEffect(() => {
        const affiliate = Cookies.get('affiliateId');
        if (!affiliate) {
            const affiliateId = params.get('affiliateId');
            if (affiliateId)
                Cookies.set('affiliateId', affiliateId ?? '');
        }
    }, []);
    return null;
}

export default Affiliate;